// get api
export const GET_ROLE_LIST_API = "GET_ROLE_LIST_API"
export const GET_ROLE_LIST_API_SUCCESS = "GET_ROLE_LIST_API_SUCCESS"

// post api
export const POST_ROLE_MASTER = "POST_ROLE_MASTER"
export const POST_ROLE_MASTER_SUCCESS = "POST_ROLE_MASTER_SUCCESS"

// delete api
export const DELETE_ROLE_LIST_ID = "DELETE_ROLE_LIST_ID"
export const DELETE_ROLE_LIST_ID_SUCCESS = "DELETE_ROLE_LIST_ID_SUCCESS"

// edit api
export const EDIT_ROLE_LIST_ID = "EDIT_ROLE_LIST_ID"
export const EDIT_ROLE_LIST_ID_SUCCESS = "EDIT_ROLE_LIST_ID_SUCCESS"

// update api
export const UPDATE_ROLE_LIST_ID = "UPDATE_UPDATE_ROLE_LIST_ID"
export const UPDATE_ROLE_LIST_ID_SUCCESS = "UPDATE_ROLE_LIST_ID_SUCCESS"

export const ROLE_API_ERROR_ACTION = "ROLE_API_ERROR_ACTION"




